import {TreeNode} from '@hconnect/common/types'
import {HeatZones as HeatZonesLayout} from '@hconnect/kilnfeature/src/modules/heatZones'
import {Loader} from '@hconnect/uikit'
import {Alert, Button, Link, Stack, Typography} from '@mui/material'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router'

import {useGetAssetConfig} from '@settings/modules/plant-setup/hooks/assetConfig/useGetAssetConfig'
import {ItemDetailsLayout} from '@settings/modules/plant-setup/plant-setup-item-layout'
import {getUrl, PLANT_ROUTES, useUrlParam} from '@settings/modules/routing'

interface HeatZonesProps {
  selectedItem: TreeNode
}

export const HeatZones: React.FC<HeatZonesProps> = ({selectedItem}) => {
  const {t} = useTranslation()
  const navigate = useNavigate()
  const plantCode = useUrlParam('plantCode')

  const {data: kilnConfig, isLoading, error} = useGetAssetConfig(selectedItem.upmId)

  if (isLoading) return <Loader />

  const isKilnConfigMissing = !kilnConfig || error?.response?.status === 404

  const isMandatoryKilnConfigSetUp =
    !isKilnConfigMissing &&
    Object.keys(kilnConfig.payload.layout).length > 0 &&
    kilnConfig.payload.configuration.name &&
    kilnConfig.payload.configuration.dimensions.diameter &&
    kilnConfig.payload.configuration.dimensions.length

  return (
    <ItemDetailsLayout>
      <Stack display="flex" flexDirection="column" gap={3} flexGrow={1}>
        {isMandatoryKilnConfigSetUp ? (
          <HeatZonesLayout assetId={selectedItem.upmId} />
        ) : (
          <Alert
            elevation={4}
            severity={'error'}
            sx={{
              borderRadius: '4px'
            }}
            action={
              <Button
                variant="contained"
                color="primary"
                size="small"
                component={Link}
                onClick={() =>
                  navigate(
                    getUrl(PLANT_ROUTES.KILN_CONFIG.path, {plantCode, kilnId: selectedItem.upmId})
                  )
                }
              >
                {t('kilnConfig.setUpKiln')}
              </Button>
            }
          >
            <Typography variant="body1">{t('kilnConfig.createKilnConfigAlert')}</Typography>
          </Alert>
        )}
      </Stack>
    </ItemDetailsLayout>
  )
}
